export const GA_TRACKING_ID = "G-N54YCFKGCZ";
export const USD_TO_AUD_RATE = 1.42;
